import React, { Component } from 'react';
import reactMixin from 'react-mixin';
import { HoverMixin } from 'shared/helpers/mixins';

@reactMixin.decorate(HoverMixin)
export default class ClearedBackgroundImage extends Component {

  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { imageSize, img } = this.props;
    return (
      <div
        style={{height: imageSize, width: imageSize, position: 'relative', ...this.props.style}}
        onMouseEnter={this.onMouseEnter.bind(this)}
        onMouseLeave={this.onMouseLeave.bind(this)}
      >
        {
          img
            ?
            <div
              style={{
                position: 'absolute',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: 'url(' + img.src + ')',
                backgroundSize: 'cover',
                height: '100%',
                width: '100%'
              }}
            />
            :
            <div
              style={{
                width: '100%',
                height: '100%',
                fontSize: 16,
              }}
            />
        }
      </div>
    );
  }
}
